import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { formattedDateDocument } from '../report-common';
import { namespace } from 'vuex-class';
import { BriefingResourceDetail, UserProfileInfo } from '@/shared/model/briefing-widget.model';

const appStoreState = namespace('appStore');
const briefingStore = namespace('briefingStore');

@Component({
  methods: { formattedDateDocument },
})
export default class reportRelated extends Vue {
  @Prop(Array) relatedPeople: any[] | [];
  @Prop(Array) relatedDocument: any[] | [];

  @appStoreState.Getter
  public isShowDetailArticle!: boolean;
  @appStoreState.Mutation
  public setShowDetailArticles!: (state?: boolean) => void;
  @appStoreState.Mutation
  public setId!: (state?: string) => void;
  @appStoreState.Getter
  public getId!: any;
  @appStoreState.Mutation
  public setShowDetailReport!: (b: boolean) => void;
  @briefingStore.Mutation
  public setSelectedResource!: (payload?: any) => void;
  startIndex = 0;
  numberItemPerPage = 5;
  endIndex = this.startIndex + this.numberItemPerPage;
  articleRelatedDocumentPages = {
    currentPage: 1,
    page: 1,
    pageSize: 5,
  };
  articleRelatedPeoplePages = {
    currentPage: 1,
    page: 1,
    pageSize: 5,
  };
  social(face, ist, xt, link) {
    if (face != null) {
      return face;
    } else if (ist != null) {
      return ist;
    } else if (xt != null) {
      return xt;
    } else if (link != null) {
      return link;
    } else {
      return null;
    }
  }
  @Watch('relatedDocument')
  displayedItemsDocument() {
    const startIndex = Math.ceil(this.articleRelatedDocumentPages.currentPage - 1) * this.articleRelatedDocumentPages.pageSize;
    const endIndex = startIndex + this.articleRelatedDocumentPages.pageSize;
    return this.relatedDocument.slice(startIndex, endIndex);
  }
  @Watch('relatedDocument')
  totalPagesDocument() {
    return Math.ceil(this.relatedDocument.length / this.articleRelatedDocumentPages.pageSize);
  }

  prevPageDocument() {
    if (this.articleRelatedDocumentPages.currentPage > 1) {
      this.articleRelatedDocumentPages.currentPage--;
    }
  }

  nextPageDocument() {
    if (this.articleRelatedDocumentPages.currentPage < this.totalPagesDocument()) {
      this.articleRelatedDocumentPages.currentPage++;
    }
  }
  @Watch('relatedPeople')
  displayedItemsPeople() {
    const startIndex = (this.articleRelatedPeoplePages.currentPage - 1) * this.articleRelatedPeoplePages.pageSize;
    const endIndex = startIndex + this.articleRelatedPeoplePages.pageSize;
    return this.relatedPeople.slice(startIndex, endIndex);
  }
  @Watch('relatedPeople')
  totalPagesPeople() {
    return Math.ceil(this.relatedPeople.length / this.articleRelatedPeoplePages.pageSize);
  }

  prevPagePeople() {
    if (this.articleRelatedPeoplePages.currentPage > 1) {
      this.articleRelatedPeoplePages.currentPage--;
    }
  }

  nextPagePeople() {
    if (this.articleRelatedPeoplePages.currentPage < this.totalPagesPeople()) {
      this.articleRelatedPeoplePages.currentPage++;
    }
  }

  handleRelatedDocument(item) {
    this.setSelectedResource({ ...item, bpId: item._id, type: 'DISCOVERY', docId: item._id });
    this.setShowDetailReport(false);
    this.setShowDetailArticles(true);
  }
}
